import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  ContainerMasonic,
  Img,
  ModalContainer,
  TextCard,
} from "./styled.compontents";
import { Modal, Skeleton } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
//@ts-ignore
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

//@ts-ignore
const Masonic = ({ items, fetchData, page, loading }: any) => {
  const [open, setOpen] = React.useState(false);
  //@ts-ignore
  const myRef: any = useRef();

  const [itemActual, setItemActual] = useState<any>({
    photo: "",
    date: "",
    sucursal: "",
  });
  const { totalPage } = useSelector((state: any) => state.common);

  const handleClose = () => setOpen(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (page === totalPage) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }

    if (page === 1) {
      myRef.current.scrollTo(0, 0);
    }
  }, [items]);

  const handleOpen = (data: any) => {
    setItemActual(data);
    setOpen(true);
  };

  const moreData = () => {
    if (totalPage === page) {
      setHasMore(false);
      return;
    }
    fetchData();
  };

  return (
    <>
      <ContainerMasonic id="scrollableDiv" ref={myRef}>
        <InfiniteScroll
          dataLength={items.length} //This is important field to render the next data
          next={moreData}
          hasMore={hasMore}
          loader={<h4>Cargando...</h4>}
          scrollableTarget="scrollableDiv"
          style={{ overflow: "hidden" }}
          endMessage={
            <p style={{ textAlign: "center" }}>
              {items.length > 0 ? (
                <b>¡No hay más datos que mostrar!</b>
              ) : (
                <b>No hay datos que mostrar</b>
              )}
            </p>
          }
        >
          {loading ? (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                style={{ margin: "20px", borderRadius: "10px 10px 0px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                style={{ margin: "20px", borderRadius: "10px 10px 0px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                style={{ margin: "20px", borderRadius: "10px 10px 0px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                style={{ margin: "20px", borderRadius: "10px 10px 0px 0px" }}
              />
            </div>
          ) : (
            <ResponsiveMasonry
              columnsCountBreakPoints={{ 350: 1, 750: 3, 900: 4 }}
            >
              <Masonry style={{ padding: "0px 20px" }}>
                {items.map((d: any, index: any) => (
                  <Card
                    className="item"
                    onClick={() => handleOpen(d)}
                    key={index}
                  >
                    {d.category && d.brand ? (
                      <TextCard className="upItem">
                        <span children={d.sucursal} />
                        <span children={d.date} />
                      </TextCard>
                    ) : (
                      ""
                    )}
                    <Img
                      loading="lazy"
                      alt={d.date}
                      src={d.photo}
                      onError={({ currentTarget }: any) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = `${process.env.PUBLIC_URL}/commons/imageNoFound.jpg`;
                      }}
                    />
                    {d.category && d.brand ? (
                      <TextCard>
                        <span children={d.category} />
                        <span children={d.brand} />
                      </TextCard>
                    ) : (
                      <TextCard>
                        <span children={d.sucursal} />
                        <span children={d.date} />
                      </TextCard>
                    )}
                  </Card>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          )}
        </InfiniteScroll>
      </ContainerMasonic>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer style={{ border: "none" }}>
          <img
            style={{ maxHeight: "90vh", maxWidth: "80%" }}
            alt={"ModalImage"}
            onError={({ currentTarget }: any) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = `${process.env.PUBLIC_URL}/commons/photo-not-available.jpg`;
            }}
            src={itemActual.photo}
          />
          <span className="name" children={itemActual.sucursal} />
          <span className="store" children={itemActual.date} />
          {itemActual.category && itemActual.brand ? (
            <>
              <span className="simple" children={itemActual.category} />
              <span className="simple" children={itemActual.brand} />
            </>
          ) : (
            ""
          )}
        </ModalContainer>
      </Modal>
    </>
  );
};

export default Masonic;
